import { createApp } from 'vue';
import App from './App.vue';
import { router, setupRouter } from '/@/router';
import { setupStore } from '/@/store';
// import 'ant-design-vue/dist/antd.css';
import { setupGlobDirectives } from '/@/directives';
import '/@/design/index.less';
import { setupRouterGuard } from '/@/router/guard';
import { registerGlobComp } from '/@/components/registerGlobComp';

import { initAppConfigStore } from '/@/core/initAppConfig';
import { useAuth } from '/@/hooks/web/useAuth';
import { useServiceStoreWithOut } from '/@/store/modules/service';

async function bootstrap() {
  const app = createApp(App);
  // 全局注册组件
  registerGlobComp(app);

  // Configure global error handling
  setupStore(app);
  setupRouter(app);
  await initAppConfigStore();
  await router.isReady();
  setupRouterGuard(router);
  // 设置权限
  app.provide('checkAuth', useAuth);
  // 建立socket连接
  const serviceStore = useServiceStoreWithOut();
  serviceStore.initWebSocket();
  // 全局指令管理
  setupGlobDirectives(app);
  app.mount('#app');
}
bootstrap();
